<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_mixins";

  .description {
    margin-bottom: utils.in_rem(16px);

    h1 {
      @include mixins.h1();
      color: colors.get(textBlack);
      margin: 0;
    }

    p {
      @include mixins.body2();
      color: colors.get(textGrey);
      margin: 0;

      a {
        color: colors.get(primary_50);
      }
    }
  }
</style>

<script>
  export let title;
  export let description;
  export let learnMoreLink = null;
</script>

<div class="description">
  <h1>{title}</h1>
  <p>
    {description}
    {#if learnMoreLink}
      <a href={learnMoreLink} target="_blank">Learn More.</a>
    {/if}
  </p>
  <slot />
</div>
